'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { reportClientSideNavigation } from '@utils/google-tag-manager';

/**
 * Tracks client-side navigations in the App Router and pushes
 * a `client_side_navigation` event to the dataLayer.
 *
 * This replaces the functionality that was previously in _app.tsx
 * which listened for Next.js route change events.
 */
export function ClientSideNavigationTracker() {
  const $ = _c(3);
  const pathname = usePathname();
  const isFirstRender = useRef(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }
      reportClientSideNavigation(window.location.href);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== pathname) {
    t1 = [pathname];
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}